import { api } from "@/lib/api/client";

export type InviteStatus = "pending" | "approved" | "rejected" | "cancelled" | "failed";

/** One invite on `/crm/colleague-invites/` (#437) — the company's admins see their company's invites. */
export interface ColleagueInvite {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  tenant_admin: boolean;
  role: string | null;
  status: InviteStatus;
  created_at: string;
  requested_by_name: string;
  decided_at: string | null;
  decided_automatically: boolean;
  /** Only on a rejected invite: the operator's reason. */
  reject_reason: string | null;
}

export interface ColleagueInviteInput {
  email: string;
  first_name: string;
  last_name: string;
  tenant_admin: boolean;
  role?: string | null;
  note?: string;
}

/** The create answer is the same for every invite (auto-approved or held for review). */
export interface ColleagueInviteSubmitted {
  id: number;
  status: "submitted";
}

export const colleagueInvitesApi = {
  list: () => api.get<ColleagueInvite[]>("/crm/colleague-invites/"),
  create: (input: ColleagueInviteInput) => api.post<ColleagueInviteSubmitted>("/crm/colleague-invites/", input),
  cancel: (id: number) => api.post<ColleagueInvite>(`/crm/colleague-invites/${id}/cancel/`),
};
